import { SystemStyleObject } from "@chakra-ui/react";

export const SCROLLBAR_STYLES: SystemStyleObject = {
  "::-webkit-scrollbar": {
    width: 1.5,
    height: 1.5,
  },
  "::-webkit-scrollbar-track": {
    bg: "brand.cloudy",
    rounded: "full",
  },
  "::-webkit-scrollbar-thumb": {
    bg: "brand.sky",
    rounded: "full",
    transition: "background 0.3s",
  },
  "::-webkit-scrollbar-thumb:hover": {
    cursor: "pointer",
    bg: "brand.creek",
  },
  "::-webkit-scrollbar-corner": {
    bg: "transparent",
  },
  html: {
    scrollBehavior: "smooth",
  },
};
